"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BASE_URL = exports.CARRIER_TYPE_OPTIONS = exports.SIZE_OPTIONS = void 0;
var SIZE_OPTIONS = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;
var CARRIER_TYPE_OPTIONS = {
  AIRLINE: "airline",
  BUS: "bus",
  TRAIN: "train",
  PRIVATE_TRANSFER: "private_transfer",
  FERRY: "ferry",
  KIWICOM: "kiwicom"
};
exports.CARRIER_TYPE_OPTIONS = CARRIER_TYPE_OPTIONS;
var BASE_URL = "//images.kiwi.com";
exports.BASE_URL = BASE_URL;